/**
 * The wire shape of a Berlin calendar day, `YYYY-MM-DD` (#1496).
 *
 * Shape only. Whether `2026-02-30` is a day that exists is a different question
 * and the domain answers it — `Date.parse` does not fail on that one, it rolls
 * over to 2 March.
 */
export const CALENDAR_DATE = /^\d{4}-\d{2}-\d{2}$/;
/**
 * Render a `Date` as the Berlin calendar day it falls on, `YYYY-MM-DD`.
 *
 * ⚠ **Local parts, never `toISOString().slice(0, 10)`.** Every Node process that
 * talks to the database runs with `TZ=Europe/Berlin`, and the MySQL driver hands
 * `timestamp` columns back as local-time `Date`s. Slicing the ISO string shifts
 * a Behandlung delivered at 00:30 back onto the previous day — and the whole
 * point of a Leistungstag is which day a human would write on the Verordnung.
 *
 * A `date` column arrives as UTC midnight and still renders correctly here: UTC
 * midnight is 01:00 or 02:00 Berlin on the same calendar day.
 */
export function toCalendarDate(date) {
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
}
/**
 * Render a Berlin calendar day as the German `DD.MM.YYYY` a person reads.
 *
 * ⚠ **Pure string work on a `YYYY-MM-DD`, with no `Date` in between.** A
 * `new Date('2026-07-01')` parses the day as UTC, which shows the same day in
 * Berlin and the day before in any western zone — and this renders dates a
 * practice acts on.
 */
export function toGermanCalendarDate(calendarDate) {
    const [year, month, day] = calendarDate.split('-');
    return `${day}.${month}.${year}`;
}
//# sourceMappingURL=calendar-date.js.map